<template>
  <button
    class="btn"
    :class="{'green': color === 'green'}"
    :disabled="disabled"
    @click.prevent="action">{{text}}</button>
</template>

<script>
export default {
  props: ['text', 'disabled', 'color'],
  methods: {
    action: function () {
      // Название функции указывается в @click. А то что в $emit - это приходит из родительского компонента
      this.$emit('action')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  display: block;
  margin: 0 auto;
  width: 280px;
  height: 60px;
  box-shadow: 0 3px 6px rgba(194, 213, 225, 0.99);
  border-radius: 5px;
  background-color: #ffffff;
  color: #0096c8;
  font-size: 20px;
  cursor: pointer;
  border: none;
  margin-top: 30px;
  transition: 0.2s;
  &:hover {
    background: #0096c8;
    color: #fff;
  }
  &.green {
    background-color: #64d282;
    color: #fff;
  }
  &:disabled {
    background-color: #c2d5e1;
    color: #fff;
    box-shadow: none;
    cursor: default;
  }
}

@media screen and (max-width: 767px) {
  .btn {
    height: 40px;
    font-size: 15px;
  }
}
</style>